import { FC } from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  tableSection: {
    "& > td": {
      padding: "0 !important",
      "& > div": {
        display: "flex",
        justifyContent: "space-between",
        "& > span": {
          padding: theme.spacing(1.25),
          fontStyle: "italic",
        },
      },
    },
  },
  tableSectionColorBorder: {
    "& > td": {
      backgroundColor: theme.custom.palette.purple.main,
      borderLeft: `1px solid ${theme.custom.palette.purple.main}`,
      borderRight: `1px solid ${theme.custom.palette.purple.main}`,
      borderBottom: `1px solid ${theme.custom.palette.purple.main}`,
      "& > div > span": {
        color: "#fff",
        fontWeight: theme.typography.fontWeightMedium,
      },
    },
  },
  tableSectionNoBorder: {
    "& > td": {
      backgroundColor: "#eeeeee",
    },
  },
}));

interface TableSectionProps {
  title: string;
  actions?: FC;
  isColorBorder?: boolean;
}

const TableSection: FC<TableSectionProps> = props => {
  const classes = useStyles();
  const className = `${classes.tableSection} ${
    props.isColorBorder
      ? classes.tableSectionColorBorder
      : classes.tableSectionNoBorder
  }`;

  return (
    <tr className={className}>
      <td colSpan={100}>
        <div>
          <span>{props.title}</span>
          {props.actions && <props.actions />}
        </div>
      </td>
    </tr>
  );
};

export default TableSection;
